import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Seo } from "@/components/site/Seo";

export default function NotFound() {
  return (
    <section className="container-x flex min-h-[60vh] flex-col items-start justify-center py-20" data-testid="not-found">
      <Seo title="Sayfa bulunamadı | Rüzgar Özel Güvenlik" noindex path="/404" />
      <ShieldAlert className="h-12 w-12 text-[color:var(--red)]" />
      <h1 className="mt-4 text-3xl font-extrabold text-zinc-950 sm:text-4xl">Sayfa bulunamadı</h1>
      <p className="mt-3 max-w-md text-zinc-600">Aradığınız sayfa taşınmış veya kaldırılmış olabilir.</p>
      <div className="mt-6 flex gap-3">
        <Link to="/" className="btn-red" data-testid="notfound-home-btn">Ana Sayfa</Link>
        <Link to="/hizmetlerimiz" className="btn-outline">Hizmetlerimiz</Link>
      </div>
    </section>
  );
}
